import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=b8d444d2"
import script from "./SessionList.vue?vue&type=script&lang=js"
export * from "./SessionList.vue?vue&type=script&lang=js"
import style0 from "./SessionList.vue?vue&type=style&index=0&id=b8d444d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports